import { render, staticRenderFns } from "./CompanyVerSpvPass.vue?vue&type=template&id=5ffbb8db&"
import script from "./CompanyVerSpvPass.vue?vue&type=script&lang=js&"
export * from "./CompanyVerSpvPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports